// extracted by mini-css-extract-plugin
module.exports = {"layout":"aed17b9412--layout--OJqC4"};